/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import axios from 'axios';
import * as models from '@/models';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export async function get() {
    const response = await axios.get('/api/v1/sso_providers/');
    return response.data.map(item => models.makeSSOProvider(item));
}
